module.exports = "/_next/static/images/medicspot-certification-logo-19966705e39d02fa5a03ac21239016e7.jpg";